module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE ON TRANSLITERATION AND TRANSLATION")])])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "span1"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLITERATING THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULGARIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRILLIC ALPHABET")]), _vm._v(" into Latin letters can be challenging because there are multiple accepted traditions including the US Library of Congress transliteration system. Throughout the book, I have followed the official Bulgarian government version published in 2013. Hence, I have transliterated Cyrillic letters as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "50%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "34%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("v")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("З")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("z")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ж")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("zh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ч")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("ch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ш")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("sh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Щ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("sht")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ц")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("ts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("h")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Й")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("y")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ю")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("yu")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Я")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("ya")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("у")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("u")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Ъ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("→")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("a")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only exception to this rule is for “Bulgaria” and names that have been conventionally spelled with “ia” instead of “ya.” All translation from Bulgarian to English throughout the book is mine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fa92de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_FM02.vue
// module id = 78
// module chunks = 0